module.exports = __webpack_public_path__ + "static/media/2piechart.569748ec.png";